type UseGumstack = {
	launchGumstack: () => any;
};

function initiateGumstack(options: { onInit: () => void }) {
	try {
		((d, s, id) => {
			const hjs = d.getElementsByTagName(s)[0];
			if (d.getElementById(id)) {
				d.getElementById('gumstack-sdk')?.remove();
			}
			const js = d.createElement(s) as HTMLScriptElement;
			js.id = id;
			js.defer = true;
			js.src = 'https://w.gumstack.com/apiembed/86008731978b760b0aa83a0f.js';
			(hjs as any).parentNode.insertBefore(js, hjs);
		})(document, 'script', 'gumstack-sdk');

		window.addEventListener('message', (event) => {
			if (event?.data?.type === 'gs:loaded') {
				options.onInit();
			}
		});
	} catch (error) {
		console.error('gumstack error', error);
	}
}

export function useGumstack(): UseGumstack {
	function launchGumstack() {
		if (!window.Gumstack) {
			initiateGumstack({
				onInit: () => {
					window.Gumstack('show');
				},
			});
		} else {
			window.Gumstack('show');
		}
	}

	return {
		launchGumstack,
	};
}
